import React from "react";
import {useSelector} from 'react-redux'
import Post from "./Post/Post";

import {Grid, CircularProgress} from '@mui/material'
import { useStyles } from "./style";


const Posts = ({setCurrentId}) => {
    const posts = useSelector((state) => state.posts)
    const classes = useStyles();
    console.log(`component/posts data using useSelector`)
    console.log(posts)
    return (
        !posts.length ? <CircularProgress /> : (
            <Grid className={classes.container} container alignItems="Stretch" spacing={3}>
                {posts.map((post) => (
                    <Grid key={post._id} item xs={12} sm={6} md={6}>
                        <Post post={post} setCurrentId={setCurrentId}/>
                    </Grid>
                ))}
            </Grid>
        )
    )
}

export default Posts;